export const VISIME_APP_STORE_URL = 'https://apps.apple.com/app/visime';
export const VISIME_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=ch.lebo_apps.visime';
